export const groupByAlphabet = <T extends { title: string }>(
  items: T[]
): Record<string, T[]> => {
  const collator = new Intl.Collator(undefined, {
    usage: 'sort',
    sensitivity: 'base',
  });

  const sorted = [...items].sort((a, b) => collator.compare(a.title, b.title));

  return sorted.reduce<Record<string, T[]>>((acc, item) => {
    const letter = item.title[0]?.toUpperCase() ?? '#';

    if (!acc[letter]) {
      acc[letter] = [];
    }

    acc[letter].push(item);
    return acc;
  }, {});
};
